import React from 'react'

import { Draggable } from '@hello-pangea/dnd'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import classnames from 'classnames'
import { semanticPalette } from '@paintscout/util/palette'
import type { Deal } from '@paintscout/api'

const useStyles = makeStyles<Theme>(
  (theme) => ({
    root: {
      border: `1px solid ${theme.paintscout.palette.brand.Neutral.P90}`,
      backgroundColor: 'white',
      borderRadius: theme.borderRadius['md'],
      padding: theme.spacing(1, 1, 0.5, 1),
      marginBottom: theme.spacing(2),
      '&:hover': {
        borderColor: theme.paintscout.palette.primary
      }
    },
    dragging: {
      backgroundColor: theme.paintscout.palette.primary,
      color: 'white'
    },
    archived: {
      borderColor: semanticPalette.Warning.S80
    }
  }),
  { name: 'BoardViewCard' }
)

export interface ContentsComponentProps {
  data: Deal
}

export interface BoardViewCardProps {
  ContentsComponent: React.FC<ContentsComponentProps>
  data: Deal
  index: number
  draggableId: string
}

function BoardViewCard(props: BoardViewCardProps) {
  const classes = useStyles(props)
  const { ContentsComponent, data, draggableId, index } = props
  return (
    <Draggable draggableId={draggableId} index={index}>
      {(provided, _snapshot) => {
        const combinedStyle = {
          ...provided.draggableProps.style,
          transition: `${provided.draggableProps.style.transition}, background-color 0.33s cubic-bezier(.2,1,.1,1), color 0.33s cubic-bezier(.2,1,.1,1)`
        }

        return (
          <div
            className={classnames(classes.root, {
              // [classes.archived]: data && data.archived,
              [classes.dragging]: _snapshot.isDragging,
              'tour-board-view-card': index === 0
            })}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={combinedStyle}
          >
            <ContentsComponent data={data} />
          </div>
        )
      }}
    </Draggable>
  )
}

export default BoardViewCard
